import { render, staticRenderFns } from "./CustomerWiseProductSaleReport.vue?vue&type=template&id=94178912&"
import script from "./CustomerWiseProductSaleReport.vue?vue&type=script&lang=js&"
export * from "./CustomerWiseProductSaleReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports